var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2618_11312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14331 11.7143C7.14331 11.9416 7.23362 12.1596 7.39436 12.3204C7.55511 12.4811 7.77312 12.5714 8.00045 12.5714C8.22778 12.5714 8.4458 12.4811 8.60654 12.3204C8.76729 12.1596 8.8576 11.9416 8.8576 11.7143C8.8576 11.487 8.76729 11.2689 8.60654 11.1082C8.4458 10.9475 8.22778 10.8571 8.00045 10.8571C7.77312 10.8571 7.55511 10.9475 7.39436 11.1082C7.23362 11.2689 7.14331 11.487 7.14331 11.7143ZM7.42902 6.28572V9.57143C7.42902 9.65 7.49331 9.71429 7.57188 9.71429H8.42902C8.5076 9.71429 8.57188 9.65 8.57188 9.57143V6.28572C8.57188 6.20714 8.5076 6.14286 8.42902 6.14286H7.57188C7.49331 6.14286 7.42902 6.20714 7.42902 6.28572ZM15.9237 14.1429L8.4951 1.28571C8.38438 1.09464 8.19331 1 8.00045 1C7.8076 1 7.61474 1.09464 7.50581 1.28571L0.0772382 14.1429C-0.142405 14.525 0.132595 15 0.571881 15H15.429C15.8683 15 16.1433 14.525 15.9237 14.1429ZM1.9326 13.6446L8.00045 3.14107L14.0683 13.6446H1.9326Z",
    fill: "#CF324A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2618_11312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warningRed.7d555ffa180739f7bf4dbebe150dd5c7.svg";
export { ForwardRef as ReactComponent };